import {
	browserName,
	browserVersion,
	isMobile,
	isTablet,
	osName,
	osVersion,
} from 'react-device-detect';
import { useSurveyContext } from '../context/useSurveryContext';
import { useIdQuestion } from './useIdQuestion';
import { IAnswer, ISurveysReceiveRequest } from '../domain/models/survey-receive.model';
import { surveysReceiveUseCase } from '../domain/use-cases/surveys.use-case';

export default function useSurveysReceive() {
	const { survey } = useSurveyContext();
	const idQuestion = useIdQuestion();
	const nssNrp = useIdQuestion('nrp');
	const { setLoading } = useSurveyContext();

	const saveSurvey = async (body: IAnswer): Promise<boolean> => {
		setLoading(true);
		const deviceType = isTablet ? '3' : isMobile ? '2' : '1';

		const bodyEncuesta: ISurveysReceiveRequest = {
			identificador: survey?.IDENTIFICADOR || '',
			idEncuesta: idQuestion,
			version: survey?.VERSION || '',
			operativeSystem: `${osName} ${osVersion}`,
			browser: `${browserName} ${browserVersion}`,
			device: deviceType,
			nssNrp: nssNrp || '',
			answers: [body],
		};

		try {
			const response = await surveysReceiveUseCase(bodyEncuesta);
			//console.log(response);
			if (response.code === '0000') {
				setLoading(false);
				return true;
			} else {
				setLoading(false);
				return false;
			}
		} catch (error) {
			//console.error('Error en la petición:', error);
			setLoading(false);
			return false;
		}
	};

	return { saveSurvey };
}
